<template>
  <div class="add-drug-container">
    <el-dialog
      :title="nameTitle"
      :visible.sync="dialogVisible"
      width="66%"
      top="12vh"
      v-loading="loading"
      class="add-drug-dialog"
      custom-class="manufacturer-dialog"
      @close="handleClose"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <template slot="title">
        <div class="dialog-header">
          <span class="dialog-header-title">{{ nameTitle }}</span>
          <div class="header-buttons">
            <el-button type="text" @click="dialogVisible = false" icon="el-icon-close" class="close-button"></el-button>
          </div>
        </div>
      </template>

      <div class="dialog-content">
        <div class="top-section">
          <div class="form-top">
            <el-form :model="form" ref="topForm" label-width="120px" size="small"
              :rules="formRules" :disabled="formDisabled || mode === 'view'">
              
              <div class="tab-content-fixed-height">
                <!-- 嵌入 BasicInfo (F2.vue)，样式已通过 custom-class 隔离 -->
                <basic-info ref="basicInfo" :form="form"
                  :form-disabled="formDisabled || mode === 'view'" :mode="mode"
                  @update="handleFormUpdate">
                </basic-info>
              </div>
            </el-form>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer" v-if="mode !== 'view'">
        <el-button size="small" type="primary" @click="submitForm">
          {{ mode === 'edit' ? '修改保存' : '确认添加' }}
        </el-button>
        <el-button size="small" @click="dialogVisible = false">关闭</el-button>
      </div>
      <div slot="footer" class="dialog-footer" v-else>
        <el-button size="small" @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BasicInfo from './F2.vue';
import { addProduction, updateProduction, getProduction } from "@/api/Outpatient/eisai.js";

export default {
  name: 'AddDrugDialog',
  components: { BasicInfo },
  data() {
    return {
      dialogVisible: false,
      nameTitle: '西药新增生产厂商',
      mode: 'add',
      loading: false,
      form: {
        applicableObject: '', businessLicense: '', businessLicensePeriod: '',
        contactNumber: '', contacts: '', creditCode: '', email: '', fax: '',
        gmp: '', gmpPeriod: '', hygieneValidityPeriod: '', hygienicLicense: '',
        manufacturerName: '', origin: '', periodValidity: '', postalCode: '',
        productionLicense: '', productionValidityPeriod: '', region: '',
        remake: '', status: 1, url: ''
      },
      formRules: {
        manufacturerName: [{ required: true, message: '请输入厂商名称', trigger: 'blur' }],
        contactNumber: [{ required: true, message: '请输入联系电话', trigger: 'blur' }]
      },
      formDisabled: false,
    };
  },
  methods: {
    async openAddModel(param = {}) {
      if (param === null || typeof param !== 'object') {
        param = {};
      }
      this.dialogVisible = true;
      this.nameTitle = param.label || '西药新增生产厂商';
      this.mode = param.mode || 'add';

      try {
        this.loading = true;
        if ((this.mode === 'edit' || this.mode === 'view') && param.id) {
          await this.loadEditData(param.id);
        } else {
          this.resetForm();
        }
      } catch (error) {
        console.error('加载数据失败:', error);
        this.$message.error('打开对话框失败');
      } finally {
        this.loading = false;
      }
    },
    open(param) { return this.openAddModel(param); },
    show(param) { return this.openAddModel(param); },

    async loadEditData(id) {
      try {
        this.loading = true;
        let res = await getProduction({ id: id });
        if (res.code === 200) {
          const data = res.data;
          this.form = {
            id: data.id, applicableObject: data.applicableObject || '',
            businessLicense: data.businessLicense || '',
            businessLicensePeriod: data.businessLicensePeriod || data.licenseValidity || '',
            contactNumber: data.contactNumber || '', contacts: data.contacts || '',
            creditCode: data.creditCode || '', email: data.email || '', fax: data.fax || '',
            gmp: data.gmp || '', gmpPeriod: data.gmpPeriod || '',
            hygieneValidityPeriod: data.hygieneValidityPeriod || '', hygienicLicense: data.hygienicLicense || '',
            manufacturerName: data.manufacturerName || '', origin: data.origin || '',
            periodValidity: data.periodValidity || '', postalCode: data.postalCode || '',
            productionLicense: data.productionLicense || '', productionValidityPeriod: data.productionValidityPeriod || '',
            region: data.region || '', remake: data.remake || '',
            status: data.status !== undefined && data.status !== null ? Number(data.status) : 1,
            url: data.url || ''
          };
        } else {
          this.$message.error(res.message || '加载数据失败');
        }
      } catch (error) {
        console.error('加载编辑数据失败:', error);
        this.$message.error('加载数据失败');
      } finally {
        this.loading = false;
      }
    },

    handleFormUpdate(updatedData) {
      this.form = { ...this.form, ...updatedData };
    },

    async submitForm() {
      this.$refs.topForm.validate(async (valid) => {
        if (!valid) {
          this.$message.error('请将必填信息填写完毕！');
          return;
        }
        try {
          this.loading = true;
          if (this.$refs.basicInfo && this.$refs.basicInfo.validateForm) {
            try {
              await this.$refs.basicInfo.validateForm();
            } catch (error) {
              this.$message.error('请填写完整的必填信息');
              this.loading = false;
              return;
            }
          }
          const submitData = { ...this.form };
          submitData.status = Number(submitData.status);
          submitData.id = this.form.id;
          let response;
          if (this.mode === 'add') {
            response = await addProduction(submitData);
          } else {
            response = await updateProduction(submitData);
          }
          if (response.code === 200) {
            this.$message.success(this.mode === 'add' ? '新增成功' : '保存成功');
            this.dialogVisible = false;
            this.$emit('refresh', response.data || null);
          } else {
            this.$message.error(response.message);
          }
        } catch (error) {
          console.error('保存失败:', error);
          this.$message.error('保存失败: ' + error.message);
        } finally {
          this.loading = false;
        }
      });
    },

    resetForm() {
      this.form = {
        applicableObject: '', businessLicense: '', businessLicensePeriod: '',
        contactNumber: '', contacts: '', creditCode: '', email: '', fax: '',
        gmp: '', gmpPeriod: '', hygieneValidityPeriod: '', hygienicLicense: '',
        manufacturerName: '', origin: '', periodValidity: '', postalCode: '',
        productionLicense: '', productionValidityPeriod: '', region: '',
        remake: '', status: 1, url: ''
      };
      this.$nextTick(() => {
        if (this.$refs.topForm) this.$refs.topForm.clearValidate();
      });
    },

    handleClose() {
      this.resetForm();
      this.dialogVisible = false;
      this.$emit('close');
    },

    resetAllValidation() {
      if (this.$refs.topForm) this.$refs.topForm.clearValidate();
      if (this.$refs.basicInfo && this.$refs.basicInfo.resetValidation) {
        this.$refs.basicInfo.resetValidation();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.add-drug-container {
  ::v-deep * { box-sizing: border-box; }
}

/* 
  ★ 关键修复：通过特定的 custom-class 及样式穿透，确保弹窗内部样式完全独立，
  不让外部 F2 的样式污染进来的同时，保证弹窗自适应高度。
*/
::v-deep .manufacturer-dialog {
  border-radius: 8px !important;
  overflow: hidden;
  height: 75vh !important;
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  
  .el-dialog__header {
    padding: 12px 20px !important;
    background: linear-gradient(135deg, #00557f 0%, #ebfaff 100%);
    flex-shrink: 0;
    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .dialog-header-title { color: #fff; font-size: 16px; font-weight: bold; }
      .header-buttons .close-button { color: #fff; font-size: 18px; padding: 0; }
    }
  }
  
  .el-dialog__body {
    padding: 0 !important;
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    /* 重置内部容器，彻底阻断外部 F2 的宽度或定位影响 */
    .dialog-content {
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      .top-section {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
        overflow: hidden;
        .form-top {
          flex: 1;
          display: flex;
          flex-direction: column;
          min-height: 0;
          overflow: hidden;
          .el-form {
            height: 100%;
            display: flex;
            flex-direction: column;
            .tab-content-fixed-height {
              flex: 1;
              display: flex;
              flex-direction: column;
              min-height: 0;
              overflow: hidden;
            }
          }
        }
      }
    }
  }
  
  .el-dialog__footer {
    padding: 12px 20px !important;
    border-top: 1px solid #ebeef5;
    background: #fff;
    flex-shrink: 0;
    z-index: 10; /* 确保底部按钮在最上层可点击 */
    .dialog-footer {
      text-align: right;
      .el-button { font-size: 13px; }
    }
  }
}
</style>